import { useState } from "react";
import { LocalStorageVariables } from "../../constants/LocalStorage";
import { TabsEnum } from "../../constants/TabsEnum";

// Utility function to safely parse stored JSON
const safeParse = (item) => {
    try {
        return JSON.parse(item);
    } catch {
        return null;
    }
};

// Get token from sessionStorage
const getStoredToken = (key) => {
    const tokenString = sessionStorage.getItem(key);
    return tokenString && tokenString !== "undefined" ? safeParse(tokenString) : '';
};

// Hook to get and set the token
export function useToken() {
    const [token, setTokenState] = useState(getStoredToken(LocalStorageVariables.PageToken));

    const saveToken = (userToken) => {
        if (userToken?.refresh_token) {
            const refreshToken = {
                refreshToken: userToken.refresh_token,
                tokenUses: 0
            };
            sessionStorage.setItem("refresh", JSON.stringify(refreshToken));
            delete userToken.refresh_token; // Remove refresh token from the main token object
        }
        sessionStorage.setItem(LocalStorageVariables.PageToken, JSON.stringify(userToken));
        setTokenState(userToken); // Update the state
    };

    return {
        setToken: saveToken,
        token
    };
}

// Retrieve access token from storage
export const getToken = () => getStoredToken(LocalStorageVariables.PageToken);

// Retrieve refresh token from storage
export const getRefreshToken = () => getStoredToken("refresh");

// Store token and refresh token in storage
export const setToken = (userToken) => {
    if (userToken?.refresh_token) {
        const refreshToken = {
            refreshToken: userToken.refresh_token,
            tokenUses: 0
        };
        sessionStorage.setItem("refresh", JSON.stringify(refreshToken));
        delete userToken.refresh_token;
    }
    sessionStorage.setItem(LocalStorageVariables.PageToken, JSON.stringify(userToken));
};

// Trigger logoff in all tabs by removing the token
export const credentialsFlush = () => {
    localStorage.setItem(TabsEnum.removeToken, Date.now().toString());
    localStorage.removeItem(TabsEnum.removeToken);
};

// Share token across tabs
export const credentialsSharing = () => {
    const token = getToken();
    const refresh = getStoredToken("refresh");
    if (token && refresh) {
        const userToken = { ...token, refresh_token: refresh.refreshToken };
        localStorage.setItem(TabsEnum.sharingCredentials, JSON.stringify(userToken));
        localStorage.removeItem(TabsEnum.sharingCredentials);
    }
};

// Request token from other tabs
export const credentialsRequest = () => {
    localStorage.setItem(TabsEnum.startingTab, Date.now().toString());
    localStorage.removeItem(TabsEnum.startingTab);
};
